import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum'

import { getCookie } from './client-cookie'

const initDatadog = () => {
  // If already initialized, bail out
  if ((window as any)?.DD_RUM?.getInternalContext()) return

  if (
    !process.env.NEXT_PUBLIC_DATADOG_APP_ID ||
    !process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ||
    !process.env.NEXT_PUBLIC_DATADOG_SITE
  )
    return

  datadogRum.init({
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APP_ID,
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    site: process.env.NEXT_PUBLIC_DATADOG_SITE,
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
    env: process.env.NEXT_PUBLIC_DATADOG_ENV,
    sessionSampleRate:
      Number(process.env.NEXT_PUBLIC_DATADOG_SESSION_SAMPLE_RATE) || 100,
    premiumSampleRate:
      Number(process.env.NEXT_PUBLIC_DATADOG_PREMIUM_SAMPLE_RATE) || 100,
    trackUserInteractions: true,
    defaultPrivacyLevel:
      (process.env.NEXT_PUBLIC_DEFAULT_PRIVACY_LEVEL as DefaultPrivacyLevel) ||
      'mask-user-input',
  })

  const cartId = process.env.NEXT_PUBLIC_BIGCOMMERCE_CART_COOKIE
    ? getCookie(process.env.NEXT_PUBLIC_BIGCOMMERCE_CART_COOKIE)
    : null
  datadogRum.setUser({ cartId })

  datadogRum.startSessionReplayRecording()

  datadogLogs.init({
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    site: process.env.NEXT_PUBLIC_DATADOG_SITE,
    env: process.env.NEXT_PUBLIC_DATADOG_ENV,
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
    sessionSampleRate:
      Number(process.env.NEXT_PUBLIC_DATADOG_SESSION_SAMPLE_RATE) || 100,
    forwardConsoleLogs: 'all',
    forwardErrorsToLogs: true,
  })
}

export default initDatadog
